// src/App.js

import './App.css';
import './App.module.css';

import RepoList from './modules/repoList/RepoList';

function App() {
  return (
    <div className="App">
      <RepoList />
    </div>
  );
}

export default App;
